const PageApplication = require('../../modules/page/frontend/application.coffee');

import FlexibleHomeApplication from '../../modules/flexible_home/frontend/application';

PageApplication.initialize();
FlexibleHomeApplication.initialize();
